import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaWhatsapp } from 'react-icons/fa';
import styles from './pagina_tatienelibrelon.module.scss';
import { getWhatsappUrl } from './dados_tatienelibrelon.ts';

type Servico = {
    grupo: string;
    titulo: string;
    texto: string;
    pontos: string[];
};

const SERVICOS: Servico[] = [
    {
        grupo: 'Acupuntura e fertilidade',
        titulo: 'Acupuntura',
        texto: 'A acupuntura é uma técnica da Medicina Tradicional Chinesa que busca promover o equilíbrio do organismo, auxiliando no alívio de dores, na redução do estresse e da tensão, e no relaxamento físico e emocional. Um cuidado individualizado para você se sentir melhor e cuidar da sua saúde de forma integral.',
        pontos: [
            'Alívio de dores, inclusive em quadros como fibromialgia',
            'Redução do estresse e da tensão',
            'Relaxamento físico e emocional',
        ],
    },
    {
        grupo: 'Acupuntura e fertilidade',
        titulo: 'Acupuntura para fertilidade',
        texto: 'No cuidado da infertilidade feminina, a acupuntura pode apoiar a ovulação, o equilíbrio hormonal e a preparação do útero para a gestação.',
        pontos: [
            'Regulação do ciclo menstrual',
            'Melhora do fluxo sanguíneo para o útero',
            'Preparação do endométrio para a implantação',
        ],
    },
    {
        grupo: 'Acupuntura e fertilidade',
        titulo: 'Fertilidade masculina na medicina chinesa',
        texto: 'A medicina chinesa olha para a fertilidade de forma ampla e também acompanha o homem nesse caminho, como apoio ao tratamento da infertilidade.',
        pontos: [
            'Apoio à qualidade e à mobilidade dos espermatozoides',
            'Cuidado complementar em disfunção erétil e varicocele',
            'Acompanhamento de casais e de tratamentos de FIV',
        ],
    },
    {
        grupo: 'Corpo e recuperação',
        titulo: 'Cuidados pós-operatório',
        texto: 'Acompanhamento após procedimentos cirúrgicos, com drenagem e tape, para uma recuperação mais confortável e bem conduzida.',
        pontos: ['Drenagem linfática no pós-operatório', 'Tape para suporte e conforto', 'Orientação individualizada'],
    },
    {
        grupo: 'Corpo e recuperação',
        titulo: 'Drenagem linfática',
        texto: 'A drenagem aumenta o volume e a velocidade da linfa pelos vasos e ductos, com manobras que imitam o bombeamento fisiológico do corpo.',
        pontos: [
            'Menos inchaço e retenção de líquido',
            'Desintoxicação e nutrição dos tecidos',
            'Melhora da textura da pele e potencializa outros tratamentos',
        ],
    },
    {
        grupo: 'Estética',
        titulo: 'Estética facial',
        texto: 'Protocolos pensados para o rosto, com um olhar clínico e delicado, para valorizar a pele sem perder a naturalidade.',
        pontos: [
            'Limpeza de pele',
            'Drenagem linfática facial',
            'Cuidado personalizado para cada pele',
        ],
    },
    {
        grupo: 'Estética',
        titulo: 'Estética corporal',
        texto: 'Procedimentos para áreas do corpo que geram desconforto estético, sempre com avaliação individual e um plano adequado à sua necessidade.',
        pontos: ['Avaliação do corpo como um todo', 'Protocolos conforme o objetivo', 'Cuidado contínuo e responsável'],
    },
];

const Servicos_tatienelibrelon: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    let grupoAtual = '';

    return (
        <div className={styles.pagina_tatienelibrelon} lang="pt-BR">
            <div className={styles.page}>
                <div className={styles.headerNav}>
                    <Link to="/tatienelibrelon" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                </div>

                <p className={styles.eyebrow}>Cuidado personalizado</p>
                <h1 className={styles.title}>Serviços</h1>
                <p className={styles.lead}>
                    Acupuntura, fertilidade, estética e recuperação. Cada atendimento é pensado para a sua história.
                </p>

                {SERVICOS.map((servico) => {
                    const mostrarGrupo = servico.grupo !== grupoAtual;
                    grupoAtual = servico.grupo;

                    return (
                        <React.Fragment key={servico.titulo}>
                            {mostrarGrupo ? <h2 className={styles.groupTitle}>{servico.grupo}</h2> : null}
                            <article className={styles.card}>
                                <div className={styles.cardBody}>
                                    <h3 className={styles.cardTitle}>{servico.titulo}</h3>
                                    <p className={styles.cardText}>{servico.texto}</p>
                                    <ul className={styles.points}>
                                        {servico.pontos.map((ponto) => (
                                            <li key={ponto}>{ponto}</li>
                                        ))}
                                    </ul>
                                    <a
                                        href={getWhatsappUrl(
                                            `Olá, Tatiene! Vim pelo Instagram e gostaria de saber mais sobre ${servico.titulo}.`
                                        )}
                                        className={styles.cardBtn}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaWhatsapp aria-hidden />
                                        Agendar
                                    </a>
                                </div>
                            </article>
                        </React.Fragment>
                    );
                })}

                <div className={styles.cta}>
                    <h2 className={styles.sectionTitle}>Precisa de ajuda?</h2>
                    <p className={styles.paragraph}>Entre em contato e tire suas dúvidas.</p>
                    <a
                        href={getWhatsappUrl(
                            'Olá, Tatiene! Vim pelo Instagram e gostaria de tirar algumas dúvidas.'
                        )}
                        className={styles.ctaBtn}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaWhatsapp aria-hidden />
                        Falar no WhatsApp
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Servicos_tatienelibrelon;
